import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ROUTE_CHANGED } from '../../utils/Constants';
import UAReduxActionTypes from './actionTypes';
/**
 * Contains the action creator functions to manage the internal state of the store.
 * @namespace UAReduxActions
 */

var actions = /*#__PURE__*/function () {
  function actions() {
    _classCallCheck(this, actions);
  }

  _createClass(actions, null, [{
    key: "resetConfiguration",

    /**
     * Resets the application configuration and user preferences.
     * @param {*} intlConfig
     * @param {*} userPreferences
     *
     * @function
     * @memberof UAReduxActions
     */
    value: function resetConfiguration(intlConfig, userPreferences) {
      return {
        type: UAReduxActionTypes.RESET_STORE_AFTER_LOGOUT,
        initialConfig: {
          intlConfig: intlConfig,
          userPreferences: userPreferences
        }
      };
    }
    /**
     * Creates an action to identify when a route location changes.
     * @param {function} dispatch the dispatch function
     * @param {Object} location the history location object
     * @function
     * @memberof UAReduxActions
     */

  }, {
    key: "routeLocationChanged",
    value: function routeLocationChanged(dispatch, location) {
      dispatch({
        type: ROUTE_CHANGED,
        payload: location
      });
    }
  }]);

  return actions;
}();

export { actions as default };